import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-x: auto
`;

export const Content = styled.span`
  overflow-y: auto;
  height: 100%;
  ${customScrollMinimal};
`;
